// src/utils/formatters.js

/**
 * Formatea el texto de respuesta del bot para renderizado en HTML.
 * @param {string} text - El texto crudo del bot.
 * @returns {string} - Texto formateado con saltos de línea y espaciado.
 */
export const formatText = (text) => {
    if (!text) return "";
    return text
        .replace(/\\"/g, '"')
        .replace(/(\d+\.)\s*\n\s*\n/g, '$1 ')
        .replace(/(\d+\.)\s*\n/g, '<br>$1 ')
        .replace(/(\d+\.\s*\d+)/g, '<br>&nbsp;&nbsp;$1')
        .replace(/\n\s*\n\s*\n/g, '<br><br>')
        .replace(/\n/g, '<br>')
        .replace(/<br>\s*<br>\s*<br>/g, '<br><br>')
        .replace(/^<br>/, '');
};

/**
 * Convierte etiquetas <chips>texto</chips> en formato compatible con ReactMarkdown
 * @param {string} text - Texto con etiquetas <chips> (puede contener múltiples líneas)
 * @returns {string} - Texto con chips convertidos a formato [chip:texto]
 */
export const parseChips = (text) => {
    if (!text) return "";

    
    // ✅ CORRECCIÓN: Usar [\s\S] para capturar TODO incluyendo saltos de línea
    // También detectar tanto <chip> como <chips>
    const formatText = text.replace(/<chips?>([\s\S]*?)<\/chips?>/g, (match, content) => {
        
        // Dividir por líneas y filtrar vacías
        const lines = content
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0);

        
        // Convertir cada línea en un chip individual
        const chips = lines
            .map(line => {
                // Sanitizar para evitar inyecciones
                const sanitized = line.replace(/[<>]/g, '');
                return `[chip:${sanitized}]`;
            })
            .join(' '); // Unir con espacio para separar los chips

        return chips;
    });

    return formatText;
};
